import { render, staticRenderFns } from "./CFormProject_CR.vue?vue&type=template&id=8d361362&scoped=true&"
import script from "./CFormProject_CR.vue?vue&type=script&lang=js&"
export * from "./CFormProject_CR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d361362",
  null
  
)

export default component.exports